module.exports = __webpack_public_path__ + "img/flot5.ec2140af.svg";